import React from 'react';
import Layout from '../../components/Layout';

const Blogpage1 = () => {
  return (
    <Layout>
      <section className="section">
        <div className="content is-medium">
          <h1>5 REASONS WHY ANNUAL FAMILY PORTRAITS ARE A MUST </h1>
          <p>
            Family living are of all kinds in today’s society – nuclear, joint,
            solo-living. In this fast paced world, families look towards
            progress and beinBlogpage1ents get lost in time, without being
            properly chronicled.
          </p>

          <p>
            The photos in a house, tell countless stories about the family and
            their journey so far. It shows their best aspects and captures the
            moment and occasion it was taken in.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Blogpage1;
